import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { SessionService } from '../services/session.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { WsAuthService } from '../http/ws-auth.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
	private isRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	constructor(
		private session: SessionService,
		private authService: WsAuthService
	) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const user = this.session.user;

		if (user?.token?.isExpired) {
			return this.handleAuthError(req, next);
		}

		// Verificamos el token del usuario que ha iniciado sesion
		let request = req;
		if (user) {
			request = this.addToken(req, user.token.access_token);
		}

		return next.handle(request)
			.pipe(catchError(error => {
				if (error instanceof HttpErrorResponse && error.status === 401) {
					return this.handleAuthError(request, next);
				} else {
					return throwError(error);
				}
			}));
	}

	private addToken(request: HttpRequest<any>, token: string) {
		return request.clone({
			headers: request.headers.set('Authorization', `Bearer ${token}`)
		});
	}

	private handleAuthError(request: HttpRequest<any>, next: HttpHandler): Observable<any> {

		if (!this.isRefreshing) {
			this.isRefreshing = true;
			this.refreshTokenSubject.next(null);

			const refresh_token = this.session.token?.refresh_token;
			return this.authService.refreshToken(refresh_token)
				.pipe(
					switchMap((token: any) => {
						this.isRefreshing = false;
						this.refreshTokenSubject.next(token);

						// Asignamos el nuevo token
						this.session.create(token);
						return next.handle(this.addToken(request, token.access_token));
					}),
					catchError(error => {
						// Si hay un error, quiere decir que venció el refresh_token (larga duración)
						// por tanto debemos mostrar/dirigir al login
						if (error instanceof HttpErrorResponse && error.status === 400) {
							// this.router.navigateByUrl('/auth/sign-in');
							this.isRefreshing = false;

							// Un artificio para hacer de nuevo la llamada y pasar por el interceptor que muestra el login
							let req = request.clone({
								headers: request.headers.set('myLogin', 'true')
							});

							return next.handle(req);
						}
						return throwError(error);
					})
				);
		} else {
			return this.refreshTokenSubject
				.pipe(
					filter(token => token != null),
					take(1),
					switchMap(token => {
						this.session.create(token);
						return next.handle(this.addToken(request, token.access_token));
					})
				);
		}
	}
}
